import React from 'react';
import { ClientContext } from '@thd-nucleus/app-render/client';
import { NewRelicBridge } from '@thd-olt-component-react/new-relic-bridge';
import { ThdAnalytics } from '@thd-olt-component-react/thd-analytics';
import { getRoutes } from './routes.js';
import { App } from './App';

ThdAnalytics.init();
NewRelicBridge.init();

document.addEventListener('DOMContentLoaded', async () => {
  const client = new ClientContext();
  client.setExperienceRoutes(getRoutes());
  client.render(<App />);
});
